import _ from 'lodash'
import moment from 'moment'
import momentTimezone from 'moment-timezone'
import { mapByTime } from './getMapByTime'

import { ChannelEvent, ChartableStatsType, ResponseChannelsChart } from 'types'

type MapType = 'day' | 'week' | 'month'

type ChartValue = {
  date: string
  value: number
}

export const getDateArray = (
  dateType: 'day' | 'week' | 'month',
  timezone: string
) => {
  let dates = []
  let currentMoment = momentTimezone.tz(timezone) // Start with the current date
  let formatType
  let periodsToSubtract

  if (dateType === 'day') {
    formatType = 'D/MM/YY'
    periodsToSubtract = 7 // Last 7 days
    let startDay = moment(currentMoment).subtract(periodsToSubtract - 1, 'days')
    for (let i = 0; i < periodsToSubtract; i++) {
      dates.push(startDay.format(formatType))
      startDay.add(1, 'days')
    }
  } else if (dateType === 'week') {
    formatType = 'W/YY'
    periodsToSubtract = 12 // Last 12 weeks
    let startWeek = moment(currentMoment).subtract(
      periodsToSubtract - 1,
      'weeks'
    )
    for (let i = 0; i < periodsToSubtract; i++) {
      dates.push(startWeek.format(formatType))
      startWeek.add(1, 'weeks')
    }
  } else {
    formatType = 'MMM/YY'
    periodsToSubtract = 12 // Last 12 months
    let startMonth = moment(currentMoment).subtract(
      periodsToSubtract - 1,
      'months'
    )
    for (let i = 0; i < periodsToSubtract; i++) {
      dates.push(startMonth.format(formatType))
      startMonth.add(1, 'months')
    }
  }

  return dates
}

export const mapChannelsChartData = (
  queries: ResponseChannelsChart[],
  dateType: MapType,
  eventType: ChartableStatsType,
  timezone: string
) => {
  //Step 1 - Get an array of dates for the current date type
  const dates = getDateArray(dateType, timezone)

  //Step 2 - Create an array of values for each date
  const getChartLineData = (
    data: ChannelEvent[] = [],
    type: ChartableStatsType,
    dates: string[],
    timezone: string
  ) => {
    const evt: ChartValue[] = dates.map(date => ({ date, value: 0 }))
    const mappedByTime = mapByTime(data, dateType, timezone)

    return evt.map(item => {
      if (mappedByTime[item.date]) {
        let summ = 0
        for (let j = 0; j < mappedByTime[item.date].length; j += 1) {
          if (type === 'total_amount') {
            summ += Number(mappedByTime[item.date][j][type] || 0) / 100
          } else {
            summ += Number(mappedByTime[item.date][j][type])
          }
        }
        return _.round(summ, 2)
      } else {
        return 0
      }
    })
  }

  const chartData = queries.map(query => {
    return getChartLineData(query?.data || [], eventType, dates, timezone)
  })

  return {
    dates: dates,
    values: chartData,
  }
}
